import { createAsyncThunk } from '@reduxjs/toolkit';
import { IUserJemisys } from '@ddot/AddToCartCommon/lib/entities';

import uiSlice from 'Redux/slices/ui';
import { AsyncThunkAPI } from 'Redux/types';
import Selectors from 'Redux/Selectors';

import Toast from 'Lib/Toast';
import Atc from '../../../../Lib/ATC';

import { ErrorTypes } from '.';

interface UpdateUserInfoJemisysThunkParams {
    idNo: string;
    salutation: string;
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    postCode: string;
    birthday: Date;
    gender: 'MALE' | 'FEMALE';
    email: string;
    password: string;
    phoneNumber: string;
}

export default createAsyncThunk<
    IUserJemisys,
    UpdateUserInfoJemisysThunkParams,
    AsyncThunkAPI
>('user/updateUserInfoJemisys', async (params, thunkAPI) => {
    const state = thunkAPI.getState();
    const userId = Selectors.getUserId(state);
    const authToken = Selectors.getAuthAuthToken(state);

    if (!authToken || !userId) {
        return thunkAPI.rejectWithValue('Something went wrong. Please try again later.');
    }

    const {
        address1, address2, city, country, postCode, state: userState, firstName, email, lastName, phoneNumber, password,
    } = params;

    const userInfo: IUserJemisys = {
        id: userId,
        address: {
            address1,
            address2,
            city,
            country,
            postCode,
            state: userState,
        },
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
    };

    const response = await thunkAPI.extra.useCases.user.updateUserInfoJemisys.execute({
        authToken,
        userInfo,
    });

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        Toast.show('Profile updated!');
        thunkAPI.dispatch(uiSlice.actions.uiSetProfileIsEditing(false));

        return userInfo;
    }

    const { type } = response.data;

    if (type === ErrorTypes.UpdateUserInfoError.InvalidFields) {
        return thunkAPI.rejectWithValue('Invalid fields. Please try again.');
    }

    if (type === ErrorTypes.UpdateUserInfoError.MissingFields) {
        return thunkAPI.rejectWithValue(response.data.message || 'Missing input. Please try again.');
    }

    return thunkAPI.rejectWithValue(response.data.message || 'Something went wrong. Please try again later.');
});
